import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { SEND_BACK_REPORT } from '@custom/constant';
import { SendBackReportArgs } from '@custom/Utils/constants/interfaces';

// Async thunk for sending back a report
export const sendBackReport = createAsyncThunk(
  'customer/sendBackReport',
  async ({ reportId }: SendBackReportArgs, { rejectWithValue }) => {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    try {
      const response = await axios.post(
        SEND_BACK_REPORT,
        { reportId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export default sendBackReport;
